import { render, staticRenderFns } from "./DxpDefaultLayout.vue?vue&type=template&id=625cdd7f&scoped=true"
import script from "./DxpDefaultLayout.vue?vue&type=script&lang=js"
export * from "./DxpDefaultLayout.vue?vue&type=script&lang=js"
import style0 from "./DxpDefaultLayout.vue?vue&type=style&index=0&id=625cdd7f&prod&scoped=true&lang=scss"
import style1 from "./DxpDefaultLayout.vue?vue&type=style&index=1&id=625cdd7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625cdd7f",
  null
  
)

export default component.exports